import { Box, styled } from '@mui/material';

import { CSSProperties } from 'react';

import breakpoints from '../../../constants/breakpoints';

export const MinimizedModal = styled('aside')(({ theme }) => ({
  bottom: 0,
  position: 'fixed',
  right: 0,
  width: 'var(--preference-compose-modal-width-desktop)',
  zIndex: 'var(--z-modals)',
  [theme.breakpoints.down(breakpoints.laptopS)]: {
    width: breakpoints.tabletS,
  },
}));

export const Content = styled('div')(() => ({
  maxHeight: 'var(--preference-compose-modal-content-height-desktop)',
  overflowY: 'auto',
  paddingInline: 'calc(var(--spacing-large) + var(--spacing-small))',
  paddingTop: 'calc(var(--spacing-medium) + var(--spacing-tiny))',
}));

export const ModalWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: 'var(--color-grey-lighter)',
  borderRadius: 'var(--border-radius-medium)',
  maxHeight: 'var(--height-full)',
  width: 'var(--preference-compose-modal-width-desktop)',
  [theme.breakpoints.down(breakpoints.laptopS)]: {
    width: breakpoints.tabletS,
  },
}));

export const WrapperRootStyles: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
};
